<!-- 卡片 -->
<template>
  <div class="ljc-block" :class="{ 'ljc-block__switch_close': !value }">
    <label for="" class="ljc-block__header">
      <span class="title">{{ title }}</span>
      <i-switch size="small" v-model="openSwitch" @on-change="switchChange" :disabled="switchDisabled" v-if="!hide"/>
      <a v-if="subTitle">{{ subTitle }}</a>
      <slot v-else name="subTitle"></slot>
    </label>
    <div class="ljc-block__content">
      <slot name="content" :valuedata="{ ni: 'hao' }"></slot>
    </div>
    <div class="ljc-block__footer-tips" v-if="text">
      <!-- <Icon type="ios-warning" /> -->
      <Icon type="ios-alert-outline" />
      <span>{{ text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OmsCard',
  props: {
    hide: {
      type: Boolean,
      default: false,
    },
    switchDisabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Boolean, String, Number],
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
    tips: {
      type: [Object, String],
      default: '',
    },
  },
  data() {
    return {
      // openSwitch: false,
    };
  },
  computed: {
    text: {
      get() {
        let text = this.tips
        if (typeof(this.tips) == 'object') {
          text = this.tips.text
        }
        return text
      }
    },
    openSwitch: {
      get() {
        return this.value;
      },
      set(val) {
        // this.openSwitch = val
        // this.$emit('change',val);
      },
    },
  },
  methods: {
    switchChange(val) {
      this.$emit('input', val); // 暂时去掉数据双向绑定，因为把数据存在了store上，要做判断之后再改store上的值
      this.$emit('change', val);
    },
  },
};
</script>

<style lang="less">
.ljc-block {
  border: 1.5px solid #83adea;
  border-radius: 6px;
  position: relative;
  margin-top: 16px;
  padding: 20px 12px 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &.ljc-block__switch_close {

    // 灰掉块
    &::before {
      content: " ";
      position: absolute;
      z-index: 1;
      background-color: rgba(243, 243, 243, .6);
      // background-color: rgba(186, 109, 109, 0.9);
      margin: 0;
      top: 16px;
      right: 0;
      bottom: 0;
      left: 0;
      // -webkit-transition: opacity 1s;
      // transition: opacity 3s;
      animation: close 1s;
    }

    @keyframes close {
      0% {
        opacity: 0;
      }

      100% {
        opacity: 1;
      }
    }
  }

  label.ljc-block__header {
    position: absolute;
    top: -10px;
    left: 10px;
    background: #fff;
    padding: 0 10px;
    display: flex;
    align-items: center;

    &>* {
      margin-left: 10px;
    }

    span {
      font-size: 16px;
      font-weight: bold;
      color: #0068b7;
    }
  }

  .ljc-block__footer-tips {
    // width: 60%;
    // background-color: #f8f8f9;

    // margin-top: 10px;
    .ark-icon {
      color: var(--s-warn);
    }

    span {
      // background-color: #f8f8f9;
      vertical-align: middle;
      color: #999;
    }
  }
}
</style>
